/**
 * WhatsApp Integration for Shopify
 * Handles product sharing, cart notifications, and order confirmations
 */

document.addEventListener('DOMContentLoaded', function() {
  // Initialize WhatsApp API if available
  if (typeof WhatsAppAPI === 'undefined') {
    console.warn('WhatsApp API not loaded');
    return;
  }

  // Product sharing functionality
  const whatsappButtons = document.querySelectorAll('[data-whatsapp-share]');
  
  whatsappButtons.forEach(button => {
    button.addEventListener('click', async function(e) {
      e.preventDefault();
      
      const phoneNumber = this.dataset.phoneNumber || 
                         window.Shopify?.settings?.whatsapp_default_phone || 
                         '';
      
      if (!phoneNumber) {
        alert('Please configure WhatsApp phone number in theme settings');
        return;
      }

      // Get product data
      if (this.dataset.productId) {
        const productData = {
          id: this.dataset.productId,
          title: this.dataset.productTitle,
          url: this.dataset.productUrl || window.location.href,
          featured_image: this.dataset.productImage,
          price: this.dataset.productPrice
        };

        // Show loading state
        const originalText = this.innerHTML;
        this.disabled = true;
        this.innerHTML = '<span>Sending...</span>';

        try {
          const result = await window.WhatsAppAPI.shareProduct(productData, phoneNumber);
          
          if (result.status === 'success') {
            // Show success message
            this.innerHTML = '<span>Sent!</span>';
            setTimeout(() => {
              this.innerHTML = originalText;
              this.disabled = false;
            }, 2000);
          } else {
            alert('Failed to send WhatsApp message. Please try again.');
            this.innerHTML = originalText;
            this.disabled = false;
          }
        } catch (error) {
          console.error('WhatsApp share error:', error);
          alert('An error occurred. Please try again.');
          this.innerHTML = originalText;
          this.disabled = false;
        }
      } else {
        // Generic share
        const currentUrl = window.location.href;
        const pageTitle = document.title;
        
        const result = await window.WhatsAppAPI.sendTextWithButton(
          phoneNumber,
          'hello_world',
          `Check this out: ${pageTitle}`,
          currentUrl
        );

        if (result.status === 'success') {
          alert('Message sent successfully!');
        } else {
          alert('Failed to send message. Please try again.');
        }
      }
    });
  });

  // Cart abandonment notification (if enabled)
  if (window.Shopify?.settings?.whatsapp_enable_cart_notifications) {
    let cartTimer;
    const cartItems = document.querySelectorAll('[data-cart-item]');
    
    if (cartItems.length > 0) {
      // Set timer for cart abandonment notification
      cartTimer = setTimeout(() => {
        // This would typically be handled server-side via webhooks
        // For client-side, we can store cart data in localStorage
        const cartData = {
          items: Array.from(cartItems).map(item => ({
            id: item.dataset.cartItemId,
            title: item.dataset.cartItemTitle,
            quantity: item.dataset.cartItemQuantity
          })),
          timestamp: Date.now()
        };
        
        localStorage.setItem('whatsapp_cart_data', JSON.stringify(cartData));
      }, 300000); // 5 minutes
    }
  }

  // Order confirmation (handled via checkout completion)
  // This would typically be done server-side via Shopify webhooks
  // For client-side, we can check for order confirmation in URL
  if (window.location.pathname.includes('/thank_you') || 
      window.location.search.includes('checkout')) {
    
    const orderData = getOrderDataFromPage();
    
    if (orderData && window.Shopify?.settings?.whatsapp_enable_order_confirmation) {
      // Extract customer phone from order data if available
      const customerPhone = orderData.phone || 
                           window.Shopify?.settings?.whatsapp_default_phone || 
                           '';
      
      if (customerPhone) {
        window.WhatsAppAPI.sendOrderConfirmation(orderData, customerPhone)
          .then(result => {
            if (result.status === 'success') {
              console.log('Order confirmation sent via WhatsApp');
            }
          })
          .catch(error => {
            console.error('Failed to send order confirmation:', error);
          });
      }
    }
  }
});

/**
 * Extract order data from thank you page
 * This is a basic implementation - may need adjustment based on theme
 */
function getOrderDataFromPage() {
  // Try to get order data from various sources
  const orderNumber = document.querySelector('[data-order-number]')?.textContent ||
                     document.querySelector('.order-number')?.textContent ||
                     '';
  
  const orderTotal = document.querySelector('[data-order-total]')?.textContent ||
                    document.querySelector('.order-total')?.textContent ||
                    '';
  
  if (orderNumber) {
    return {
      order_number: orderNumber.trim(),
      total_price: orderTotal.trim(),
      order_status_url: window.location.href
    };
  }
  
  return null;
}

/**
 * Format phone number for WhatsApp API
 * @param {string} phone - Phone number
 * @returns {string} - Formatted phone number
 */
function formatPhoneNumber(phone) {
  // Remove all non-numeric characters
  return phone.replace(/\D/g, '');
}

